import logo from './logo.svg';
import './App.css';
import Home from './Pages/Home/Home';
import RightIcon from './Shared/RightIcon/RightIcon';
import Email from './Shared/Email/Email';
import Footer from './Shared/Footer/Footer';
import Nav from './Shared/Nav/Nav';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ScrollToTop from "react-scroll-to-top";


AOS.init();

function App() {
  return (
    <div className="max-w-[1400px] mx-auto">
      <Nav />
      <div className='flex justify-between relative'>
        <RightIcon />
        <div className='max-w-[1075px] mx-auto'>
          <Home />
        </div>
        <Email />
      </div>
      <div className=''>
        <ScrollToTop width="20" top="30" className="scroll-icon " color='white' smooth />
      </div>
      <Footer />
    </div>
  );
}

export default App;
